import React, { useEffect, useState } from 'react';
import axios from 'axios';

const Page_header2 = () => {
  const [references, setReferences] = useState([]);
  const Url = process.env.REACT_APP_URL_DEV;

  useEffect(() => {
    axios
      .get(`${Url}/api/References/all`)
      .then((res) => {
        if (res.data && res.data.data) {
          setReferences(res.data.data.filter((item) => item.isDeleted === 0));
        }
      })
      .catch((err) => {
        console.error('Erreur lors de la récupération des références :', err);
      });
  }, []);

  return (
    <div
      className="page-header2-area pd-top-80"
      style={{ backgroundColor: '#f8f8f8' }}
    >
      <div className="container">
        <div className="page-header2-inner">
          <div className="section-title mb-0 text-center">
            <h2 className="page-title">Nos Références</h2>
          </div>

          <div
            className="references-area mt-4"
            style={{ backgroundColor: 'transparent' }}
          >
            <div
              className="references-grid"
              style={{ backgroundColor: 'transparent' }}
            >
              <div className="row justify-content-center">
                {references.map((ref, index) => (
                  <div
                    className="col-lg-3 col-md-4 col-sm-12 mb-4"
                    key={ref.RefId}
                  >
                    <div className="reference-item">
                      <img
                        src={`${Url}/images/${ref.RefImage}`}
                        alt={ref.RefTitre || `ref-${index}`}
                        style={{ maxWidth: '100%', height: 'auto' }}
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Page_header2;
